import LegalDocLayout from "@/pages/_legal/LegalDocLayout";

export default function PrivacyPage() {
  return (
    <LegalDocLayout
      titleKey="legal.privacyTitle"
      introKey="legal.privacyIntro"
      prefix="p"
      countKey="legal.privacySectionsCount"
      lastUpdated="2026-09-01"
    />
  );
}
